import request from "@/api";
// @ts-ignore
import sendEventSourceRequest from "@/utils/fetchEventSource.js";
import { getCookie } from "@/utils";
import QueryString from "qs";

/**
 *
 * 获取当前历史会话（加载更多时候）
 */
export const getOneChatSession = (data: any) =>
  request.post("/api/v1/get-one-chat-session", data);

export const getOneChatSessionVerbose = (data: any) =>
  request.post("/api/v1/get-one-chat-session-verbose", data);

/**
 *
 * 获取所有会话
 */
export const getAllSession = () => request.get("/api/v1/get-all-chat-session");

/**
 *
 * 获取新sessionid
 */
export const getChatSessionId = () =>
  request.get("/api/v1/create-chat-session");

/**
 *
 * 获取新get-all-agent
 */
export const allAgent = () => request.get("/agent/get-all-agent");

/**
 *
 * 删除会话
 */
export const delSessionId = (data: any) =>
  request.delete("/api/v1/delete-chat-session", data);

/**
 *
 * 流式聊天
 */
export const aiChat = (data: any, success: any, fail: any, _signal: any) => {
  return sendEventSourceRequest(
    "/api/v1/text-or-image-chat",
    "POST",
    data,
    {
      Authorization: getCookie("Authorization"),
      "Content-Type": "application/json",
    },
    success,
    fail,
    _signal
  );
};

/**
 * 获取所有模型
 */
export const getAllModels = () => request.get("/api/v1/user/get-models-info");

export const getRechargeInfo = () =>
  request.get("/api/v1/user/get-recharge-info");

export const userGreeting = (data: {
  agent_name: string;
  model: string;
  session_id: string;
}) => request.post("/api/v1/agent/greeting", data);

export const aiUserGreeting = (
  data: any,
  success: any,
  fail: any,
  _signal: any
) => {
  return sendEventSourceRequest(
    "/api/v1/agent/greeting",
    "POST",
    data,
    {
      Authorization: getCookie("Authorization"),
      "Content-Type": "application/json",
    },
    success,
    fail,
    _signal
  );
};

export const getUserLastModel = () => request.get("api/v1/user/model/last");

export const getReferralLink = () => request.get("api/v1/user/referral-link");

export const getUserRecharge = (data: { order_type_id: string }) =>
  request.post("api/v1/user/recharge", data);

export const getOrderStatus = (data: { order_no: string }) =>
  request.post("user/get_order_status", data);

export const updateGlobalConfig = (data: {
  search_config: {
    return_num: number;
  };
  text_or_image_chat_config: {
    top_p: number;
    detail: string;
    max_tokens: number;
    text_model: string;
    image_model: string;
    temperature: number;
    history_turns: number;
    presence_penalty: number;
    frequency_penalty: number;
  };
}) => {
  return request.put("api/v1/user/update-global-config", data);
};

export const getGlobalConfig = () => {
  return request.get("/api/v1/user/get-global-config");
};

export const getModelPermission = (model: string, agent: string) =>
  request.post("/api/v1/user/model/user_permission", {
    model,
    agent,
  });

export const getAgentSession = (data: { agent_name: string }) => {
  return request.post("/api/v1/agent/get-agent-session", data);
};

export const uploadFile = (formData: any) => {
  return request.post("/api/v1/upload-files", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};


export const getMasterCourse = (data: {
  subjects: string[];
  levels: string[];
  limit: number;
  offset: number;
}) => {
  return request.post("/api/v1/public/get-master-course", data);
};

export const getCourseSubjectsAndLevels = () => {
  return request.get("/api/v1/public/get-course-subjects-and-levels");
};

export const getUserLevels = () => {
  return request.get("/api/v1/public/user_levels");
};

export const uploadDiagnosisFile = (formData: any) => {
  return request.post("/api/v1/ai-diagnosis/diagnosis/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getDiagnosisSubjects = () => {
  return request.get(`/api/v1/ai-diagnosis/diagnosis/subjects`);
};

export const getDiagnosisAnalysis = (data: Record<string, string[]>) => {
  return request.post("/api/v1/ai-diagnosis/diagnosis/analyze", data, { timeout: 5 * 60 * 1000 });
}

export const downloadDiagnosisReport = () => {
  return request.get(`/api/v1/ai-diagnosis/diagnosis/report`);
}

export const getDiagnosisCalendar = () => {
  return request.get(`/api/v1/ai-diagnosis/diagnosis/last_calendar`);
}

export const getDiagnosisLastReport = () => {
  return request.get(`/api/v1/ai-diagnosis/diagnosis/last_report`);
}

export const getAudio = (data:
  {
    session_id: string;
    dialogue_id: string;
  }) => {
  return request.post("/api/v1/chat/get-audio", data);
}


// JSON.stringify({
//   "subject": "数学",
//   "knowledge": "计算。。。"
// })

export const getStartStudy = (data: any): Promise<{
  data: {
    agent: string;
    agent_icon: string;
  }
}> => {
  return request.post("/api/v1/ai-diagnosis/diagnosis/start_study", data);
}

export const getRecommandPrompt = (data: {
  session_id: string;
  agent_name: string;
}) => {
  return request.post("/api/v1/chat/get-recommand-prompt", data);
}


export const getDiagnosisStudyProfile = (): Promise<{
  data: {
    name: string;
    level: string;
    province: string;
    city: string;
    distinct: string;
    subjects: string[];
  }
}> => {
  return request.get(`/api/v1/ai-diagnosis/diagnosis/study_profile`);
}

export const saveDiagnosisStudyProfile = (data: any) => {
  return request.post(`/api/v1/ai-diagnosis/diagnosis/study_profile`, data);
}

export const getDiagnosisHint = () => {
  return request.get(`/api/v1/ai-diagnosis/diagnosis/hint`);
}

export type Charpter = {
  title: string,
  contents: {
    sub_title: string,
    sub_contents: string[]
  }[]
}

export const getCustomCourse = (queryString: string): Promise<{
  data: {
    title: string;
    description: string;
    chapters: Charpter[]
  }
}> => {
  return request.post(`/api/v1/ai-diagnosis/diagnosis/query_to_course`, {
    query: queryString
  }, { timeout: 2 * 60 * 1000 })
}

export type courseType = {
  subject: string;
  insert_type: 'before' | 'after' | 'replace' | 'random',
  chapters: {
    title: string,
    contents: {
      sub_title: string,
      sub_contents: string[]
    }[]
  }[]
}
export const insertCourse = (data: courseType) => {
  return request.post(`/api/v1/ai-diagnosis/diagnosis/insert_calendar`, data)
}
